export class JdoodleDataOutput {
  output: string;
  statuscode: string;
  memory: string;
  cputime: string;
}
